import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_breadcrumbs, {
      items: [{ title: _ctx.$t('memoru.albumList'), href: '/memoru/top', color:'primary' }, { title: '' }],
      class: "px-0"
    }, null, 8, ["items"]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('memoru.upload')), 1),
    _createVNode(_component_v_form, {
      modelValue: _ctx.isFormValid,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFormValid) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "pt-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('memoru.album')) + "*", 1),
                    _createVNode(_component_v_select, {
                      items: _ctx.albums ? _ctx.albums.items : [],
                      modelValue: _ctx.input.albumId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.albumId) = $event)),
                      rules: [_ctx.required],
                      "item-title": "title",
                      "item-value": "albumId",
                      variant: "outlined",
                      "no-data-text": "読み込み中...",
                      disabled: _ctx.loading,
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["items", "modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('memoru.photoDate')) + "*", 1),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.input.date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.date) = $event)),
                      rules: [_ctx.required],
                      disabled: _ctx.loading,
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      type: "date"
                    }, null, 8, ["modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('memoru.category')) + "*", 1),
                    _createVNode(_component_v_select, {
                      items: _ctx.multimediaCategoryType,
                      rules: [_ctx.required],
                      modelValue: _ctx.input.category,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.category) = $event)),
                      disabled: _ctx.loading,
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["items", "rules", "modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _ctx.onDrop
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common_actions.selectFile')) + "*", 1),
                    _createVNode(_component_v_file_input, {
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.files) = $event)),
                      disabled: _ctx.loading,
                      rules: [_ctx.required],
                      label: _ctx.$t('memoru.dragDropHint'),
                      class: "pt-1",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      height: "120px",
                      multiple: ""
                    }, null, 8, ["modelValue", "disabled", "rules", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onDrop"]),
            _createVNode(_component_v_row, { class: "pt-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.clickUpload,
                      loading: _ctx.loading,
                      disabled: !_ctx.isFormValid,
                      color: "primary",
                      variant: "flat",
                      large: "",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('memoru.upload')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}